
import { GET_COUNTRIES } from '../types';
import createAsyncActions from '../utilities/createAsyncActions';

export const {
  getCountries,
  getCountriesPending,
  getCountriesFulfilled,
  getCountriesRejected,
} = createAsyncActions(GET_COUNTRIES, 'getCountries');


// WEBPACK FOOTER //
// ./src/actions/getCountriesActions.js